import 'angular';

import workshopDataIcon              from 'icons/workshop-data.svg';

import AddNoteHtml                   from './templates/invoice.note.add.html';
import AdviserSearchResultsHtml      from '../../app-lite/advisers/templates/advisers.search.results.html';
import BursonJobCardHtml             from '../burson/templates/burson.job-card.html';
import CurrencyCellHtml              from '../../app-lite/grids/templates/cell.currency.html';
import CustomerSearchResultsHtml     from '../../app-lite/customers/templates/customers.search.results.html';
import DynamicColorSelectableRowHtml from '../../app-lite/grids/templates/row.dynamic-color.selectable.html';
import EditableCellHtml              from '../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml      from '../../app-lite/grids/templates/cell.currency.editable.html';
import EditableNumberCellHtml        from '../../app-lite/grids/templates/cell.number.editable.html';
import EmailJobCardHtml              from './templates/invoice.email-job-card.html';
import InvoiceActionCellHtml         from '../invoices/templates/invoice.action.cell.html';
import InvoiceBomActionCellHtml      from '../../app-lite/grids/templates/cell.bom-action.html';
import InvoiceFooterHtml             from './templates/invoice.footer.html';
import InvoiceSerialNumbersCtrl      from './invoice.serial-numbers.html';
import NumberCellHtml                from '../../app-lite/grids/templates/cell.number.html';
import ProductInfoHtml               from '../products/templates/product.info.html';
import ProductSearchCellHtml         from '../../app-lite/products/templates/product-search.cell.html';
import RepcoJobCardHtml              from '../repco/templates/repco.job-card.html';
import RepcoOrderConfirmationHtml    from '../repco/templates/repco.order-confirmation.html';
import RepcoOrdersHtml               from '../repco/templates/repco.orders.html';
import UnsortableHeaderCellHtml      from '../../app-lite/grids/templates/cell.unsortable-header.html';
import WindowFlipHtml                from '../../app-lite/core/templates/window-flip.html';

export function InvoiceCtrl (
  $filter,
  $q,
  $scope,
  $state,
  $templateCache,
  $timeout,
  $translate,
  $uibModal,
  $window,
  API,
  AshdownInvoices,
  attachments,
  bigDecimalApi,
  bursonApi,
  cashInvoiceApi,
  companyApi,
  companyMessages,
  confirm,
  credits,
  customer,
  Customer,
  customerSources,
  defaultTaxGroup,
  event,
  gridAPI,
  gsfApi,
  haynesProApi,
  HsyItems,
  inspections,
  internals,
  invoice,
  Invoice,
  invoiceApi,
  jobCards,
  jobStatus,
  LoanCarInvoices,
  messages,
  messengerApi,
  Mitchell1,
  modalApi,
  onlinePaymentsApi,
  OscarInvoices,
  PartsAuthorityInvoice,
  partstechApi,
  payment_methods,
  payments,
  paymentTerms,
  productApi,
  productSearchApi,
  PROLinkInvoices,
  quotes,
  reorderGrid,
  sessionObjAPI,
  stripeApi,
  taxGroups,
  templatedWording,
  tillpaymentsApi,
  tireconnectApi,
  Tiremetrix,
  vehicle,
  vehicleApi,
  vvGarageApi,
  windowApi,
  workshopAPI,
  workshopPayApi,
) {

  $scope.customerSearchResultsTemplateUrl = CustomerSearchResultsHtml;
  $scope.invoiceFooterTemplateUrl         = InvoiceFooterHtml;

  $scope.loaded = true;

  $scope.API                      = API;
  $scope.attachments              = attachments || [];
  $scope.company                  = sessionObjAPI.company();
  $scope.companyMessages          = companyMessages;
  $scope.currency                 = sessionObjAPI.currency();
  $scope.distanceLabel            = sessionObjAPI.getDistanceLabel();
  $scope.editable                 = invoice ? invoice.invoice_status === 'O': true;
  $scope.inspections              = inspections;
  $scope.jobCards                 = jobCards;
  $scope.jobStatus                = jobStatus;
  $scope.payment_methods          = payment_methods;
  $scope.paymentTerms             = paymentTerms;
  $scope.payments                 = payments;
  $scope.quotes                   = quotes;
  $scope.event                    = event;
  $scope.credits                  = credits;
  $scope.session                  = sessionObjAPI.base();
  $scope.taxGroups                = taxGroups;
  $scope.company_settings         = $scope.company.company_settings;
  $scope.company_invoice_settings = $scope.company.company_invoice_settings;
  $scope.customerSources          = customerSources;
  $scope.workshopDataIcon         = workshopDataIcon;
  $scope.workshopPayApi           = workshopPayApi;

  window._templateCache = $templateCache;

  workshopAPI.get('/system/invoice_types', null, 'invoiceTypes')
  .then(types => {
    $scope.invoice_types = types;
  });

  $scope.customer = customer || {
    id             : '',
    customer_type  : 'I',
    cash_or_account: 'C',
    price_type     : '1'
  };

  $scope.vehicle = vehicle || {
    id          : '',
    customer_id : $scope.customer.id,
    body_type   : 'SEDAN',
    transmission: 'N/A',
    automatic   : true,
    air_con     : true,
  };

  $scope.invoice = invoice || Invoice.getInitialInvoice($scope.customer, $scope.payment_terms, $scope.customerSources);

  $scope.invoice.vehicle_id = $scope.vehicle.id || '',

  $scope.originalDiscount = $scope.invoice.discount;

  $scope.attachmentOptions = {
    contact: {
      email: $scope.customer.email,
      phone: $scope.customer.mobile || $scope.customer.phone
    },
    description: 'Invoice attachment',
    entity     : $scope.invoice,
    id_key     : 'invoice_id',
    open       : $scope.attachments.length,
    table      : 'invoice',
    routes     : {
      create: '/invoice/attach_photo',
      delete: '/invoice/remove_attachment',
      get   : 'invoice/list_all_attachments'
    }
  };

  $scope.Invoice = new Invoice($scope.invoice, $scope.taxGroups);

  $scope.getServiceAdviserDetails = function ( id ) {
    return workshopAPI.get('/service_adviser', id);
  };

  if ($scope.invoice.id) {
    if ($scope.invoice.loan_car_id) {
      workshopAPI.get('/loan_car', $scope.invoice.loan_car_id).then(function (data) {
        $scope.loan_car = data;
        $scope.LoanCarInvoices = new LoanCarInvoices($scope.loan_car, $scope.Invoice.invoice, $scope.customer);
      });
    }
    else {
      $scope.loan_car = [];
      $scope.LoanCarInvoices = new LoanCarInvoices($scope.loan_car, $scope.Invoice.invoice, $scope.customer);
    }

    if ( $scope.invoice.assigned_service_adviser_id ) {
      $scope.getServiceAdviserDetails($scope.invoice.assigned_service_adviser_id)
      .then( serviceAdviser => {
        $scope.invoice.service_adviser_display_name = serviceAdviser.display_name;

        $scope.serviceAdviserSearch.value = {
          display_name: $scope.invoice.service_adviser_display_name,
          id          : $scope.invoice.assigned_service_adviser_id
        };
      });
    }
  }

  $scope.updatePaymentTerm = function() {
    if ($scope.invoice.cash_or_account == 'C') {
      $scope.invoice.invoice_payment_terms = 'CASHONDEL';
    }
    else {
      $scope.invoice.invoice_payment_terms = Invoice.getPaymentTermFromCustomer($scope.customer);
    };
  };

  $scope.filterTaxGroup = function (id) {
    $scope.invoice.tax_group = $scope.taxGroups.filter(function (group) {
      return group.id === id;
    })[0];
  };

  $scope.Ashdown                = new AshdownInvoices($scope.Invoice, $scope.vehicle);
  $scope.Company                = companyApi;
  $scope.Customer               = new Customer($scope.customer);
  $scope.HsyItems               = new HsyItems($scope.customer, $scope.vehicle, 'invoice');
  $scope.Mitchell1              = new Mitchell1($scope.customer, $scope.vehicle);
  $scope.OscarInvoices          = new OscarInvoices($scope.Invoice, $scope.vehicle);
  $scope.PartsAuthorityInvoice  = new PartsAuthorityInvoice($scope.customer, $scope.vehicle);
  $scope.PROLink                = new PROLinkInvoices($scope.Invoice, $scope.vehicle);
  $scope.Tiremetrix             = new Tiremetrix();

  $scope.hasWorkshopPaySurcharges  = stripeApi.hasSurcharges($scope.invoice);
  $scope.hasTillPaySurcharges      = tillpaymentsApi.hasSurcharges($scope.invoice);
  $scope.showLinkedInvoices        = false;
  $scope.workshopPaySurchargeLabel = stripeApi.getSurchargeLabel();

  $scope.addPartstechLabor = function () {
    $q.when()
    .then(() => {
      return $scope.Invoice.form.$dirty || !$scope.invoice.id
        ? confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {
            name: $translate.instant('PARTSTECH_SPACE.PARTSTECH_LABOUR')
          }), null, 'partstechLaborInvoiceAutoSave')
          .then(() => $scope.Invoice.save())
        : $q.when($scope.invoice);
    })
    .then(invoice => partstechApi.addLabor({
      id  : invoice.id,
      type: 'invoice'
    }, $scope.vehicle))
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $state.reload();
    });
  };

  $scope.createLoan = function () {
    $scope.LoanCarInvoices.createLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.startLoan = function () {
    $scope.LoanCarInvoices.startLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.returnLoan = function () {
    $scope.LoanCarInvoices.returnLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.reviewLoan = function () {
    $scope.LoanCarInvoices.reviewLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.viewOriginal = function (property) {
    $scope.Invoice.getOriginalInvoiceUrl(property).then(function (data) {
      $state.go('app.invoice', data);
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.viewSplit = function () {
    $scope.Invoice.getSplitInvoiceUrl().then(function (data) {
      $state.go('app.invoice', data);
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.createInspection = function () {
    workshopAPI.get('/invoice/create_inspection', $scope.invoice.id).then(function (data) {
      $state.go('app.inspection', {
        customer_id: data.customer_id,
        vehicle_id : data.vehicle_id,
        id         : data.id
      });
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.customerSelected = function (customer) {
    /**
     * some invoice defaults are set based on the customer data.
     * So to ensure those defaults come through, set them before
     * saving the copy.
     *
     * WOR-2590 & WOR-2621
     */
    $scope.invoice.cash_or_account       = customer.cash_or_account;
    $scope.invoice.customer_id           = customer.id;
    $scope.invoice.customer_source       = Invoice.getSourceFromCustomer(customer, $scope.customerSources);
    $scope.invoice.invoice_payment_terms = Invoice.getPaymentTermFromCustomer(customer);
    $scope.invoice.tax_free              = customer.tax_free;

    sessionObjAPI.setKey('invoice_copy', $scope.invoice);

    $scope.Invoice.form.$setPristine();

    $state.go('app.invoice', {
      customer_id: customer.id
    });
  };

  $scope.vehicleSelected = function (vehicle) {
    var navigate = function (invoice) {
      $state.go('app.invoice', {
        customer_id: invoice.customer_id,
        vehicle_id : vehicle.id,
        id         : invoice.id
      });
    };

    if ($scope.Invoice.form.$dirty) {
      confirm.generic($translate.instant('JS_SPACE.CONFIRM.LOSS_OF_UNSAVED_INFORMATION'))
        .then(function () {
          return $scope.save();
        }).then(function (invoice) {
          navigate(invoice);
        }, function (err) {
          messages.error(err);
        });

      return;
    }

    navigate($scope.Invoice.invoice);

  };

  $scope.show_hours_worked = $scope.company_invoice_settings.invoice_hours_worked_field;

  $scope.littleDefs = [
    {
      cellTemplate      : InvoiceBomActionCellHtml,
      displayName       : '',
      enableCellEdit    : false,
      headerCellTemplate: UnsortableHeaderCellHtml,
      width             : '43px'
    },
    {
      cellClass           : 'Uppercase',
      displayName         : $translate.instant('PRODUCT_SPACE.PRODUCT'),
      editableCellTemplate: ProductSearchCellHtml,
      field               : 'item_code',
      width               : '175px'
    },
    {
      cellClass            : 'Capitalize',
      cellEditableCondition: 'editable && row.entity.product_id',
      displayName          : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
      editableCellTemplate : EditableCellHtml,
      field                : 'description'
    },
    {
      cellClass            : 'align-right',
      cellEditableCondition: 'editable && !row.entity.is_bom_parent && row.entity.product_id',
      cellFilter           : 'globalCurrency',
      cellTemplate         : CurrencyCellHtml,
      displayName          : $translate.instant('JS_SPACE.COLUMNS.UNIT_PRICE'),
      editableCellTemplate : EditableCurrencyCellHtml,
      field                : 'unit_price',
      min                  : -99999,
      width                : '101px'
    },
    {
      cellClass            : 'align-right',
      cellEditableCondition: 'canEditQuantity(row.entity)',
      cellFilter           : 'number',
      cellTemplate         : NumberCellHtml,
      displayName          : 'Qty',
      editableCellTemplate : EditableNumberCellHtml,
      field                : 'quantity',
      width                : '61px'
    },
    {
      cellClass         : 'align-right ReadOnly',
      cellFilter        : 'globalCurrency',
      cellTemplate      : CurrencyCellHtml,
      displayName       : $translate.instant('INVOICE_SPACE.LINE_TOTAL'),
      enableCellEdit    : false,
      field             : 'getTotal()',
      headerCellTemplate: UnsortableHeaderCellHtml,
      width             : '101px'
    },
    {
      cellTemplate  : InvoiceActionCellHtml,
      displayName   : '',
      enableCellEdit: false,
      width         : '43px'
    }
  ];

  $scope.bigDefs = [
    {
      cellTemplate      : InvoiceBomActionCellHtml,
      displayName       : '',
      enableCellEdit    : false,
      headerCellTemplate: UnsortableHeaderCellHtml,
      width             : '43px'
    },
    {
      cellClass           : 'Uppercase',
      displayName         : $translate.instant('PRODUCT_SPACE.PRODUCT'),
      editableCellTemplate: ProductSearchCellHtml,
      field               : 'item_code',
      headerCellTemplate  : UnsortableHeaderCellHtml,
      width               : '175px'
    },
    {
      cellClass            : 'Capitalize',
      cellEditableCondition: 'editable && row.entity.product_id',
      displayName          : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
      editableCellTemplate : EditableCellHtml,
      field                : 'description',
      headerCellTemplate   : UnsortableHeaderCellHtml
    }
  ];

  if ($scope.Company.isFlatRateEnabled()) {
    $scope.bigDefs = $scope.bigDefs.concat({
      cellClass            : 'align-right',
      cellEditableCondition: 'isFlatRateEditable(row.entity)',
      cellTemplate         : NumberCellHtml,
      displayName          : $translate.instant('GENERAL_SPACE.FIELD.FLAT_RATE'),
      editableCellTemplate : EditableNumberCellHtml,
      field                : 'flat_rate',
      headerCellTemplate   : UnsortableHeaderCellHtml,
      min                  : row => 0,
      max                  : row => 999999,
      width                : '110px'
    });
  }

  if ($scope.show_hours_worked) {
    $scope.bigDefs = $scope.bigDefs.concat({
      cellClass         : 'align-right ReadOnly',
      cellFilter        : 'number',
      cellTemplate      : NumberCellHtml,
      displayName       : $translate.instant('VEHICLE_SPACE.HOURS'),
      enableCellEdit    : false,
      field             : 'hours_worked',
      headerCellTemplate: UnsortableHeaderCellHtml,
      width             : '93px'
    });
  }

  $scope.bigDefs = $scope.bigDefs.concat([
    {
      cellClass            : 'align-right',
      cellEditableCondition: 'editable && !row.entity.is_bom_parent && !editMode && row.entity.product_id',
      cellFilter           : 'globalCurrency',
      cellTemplate         : CurrencyCellHtml,
      displayName          : $translate.instant('JS_SPACE.COLUMNS.UNIT_PRICE'),
      editableCellTemplate : EditableCurrencyCellHtml,
      field                : 'unit_price',
      headerCellTemplate   : UnsortableHeaderCellHtml,
      min                  : -99999,
      onChange             : row => $scope.validateRRP(row.rowIndex),
      width                : '101px'
    },
    {
      cellClass            : 'align-right',
      cellEditableCondition: 'editable && !row.entity.is_bom_parent && !editMode && row.entity.product_id',
      cellTemplate         : NumberCellHtml,
      displayName          : $translate.instant('PRODUCT_SPACE.QTY'),
      editableCellTemplate : EditableNumberCellHtml,
      field                : 'quantity',
      headerCellTemplate   : UnsortableHeaderCellHtml,
      width                : '61px'
    }
  ]);

  if (!$scope.invoice.hide_cost_field) {
    $scope.bigDefs = $scope.bigDefs.concat(
      {
        cellClass         : 'align-right ReadOnly',
        cellFilter        : 'globalCurrency',
        cellTemplate      : CurrencyCellHtml,
        displayName       : 'Unit Cost',
        enableCellEdit    : false,
        field             : $scope.company.price_includes_tax ? 'cost_including_tax' : 'unit_cost',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '101px'
      }
    );
  };

  // only show this column for nrma users.
  if ($scope.Company.isBrand('nrma')) {
    $scope.bigDefs = $scope.bigDefs.concat(
      {
        cellClass           : 'align-right ReadOnly',
        cellFilter          : 'globalCurrency',
        cellTemplate        : CurrencyCellHtml,
        displayName         : $translate.instant('PRODUCT_SPACE.RRP'),
        editableCellTemplate: EditableCurrencyCellHtml,
        enableCellEdit      : true,
        field               : 'adjusted_retail_price',
        headerCellTemplate  : UnsortableHeaderCellHtml,
        onBlur              : row => $timeout(() => $scope.validateRRP(row.rowIndex)),
        width               : '100px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        cellFilter        : 'globalCurrency',
        cellTemplate      : CurrencyCellHtml,
        displayName       : $translate.instant('PRODUCT_SPACE.DISCOUNT'),
        enableCellEdit    : false,
        field             : 'discount_total',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '100px'
      }
    );
  }

  $scope.bigDefs = $scope.bigDefs.concat(
  {
    cellClass         : 'align-right ReadOnly',
    cellFilter        : 'globalCurrency',
    cellTemplate      : CurrencyCellHtml,
    displayName       : $translate.instant('INVOICE_SPACE.LINE_TOTAL'),
    enableCellEdit    : false,
    field             : 'getTotal()',
    headerCellTemplate: UnsortableHeaderCellHtml,
    width             : '101px'
  },
  {
    cellTemplate  : InvoiceActionCellHtml,
    displayName   : '',
    enableCellEdit: false,
    width         : '43px'
  });

  if (!$scope.company.use_multi_tax) {
    $scope.bigDefs.splice($scope.bigDefs.length-2, 0, {
      field             : 'getTax()',
      displayName       : $scope.currency.tax_name,
      cellFilter        : 'globalCurrency',
      cellTemplate      : CurrencyCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml,
      enableCellEdit    : false,
      width             : '93px',
      cellClass         : 'align-right ReadOnly'
    });
  }

  $scope.defs = parseInt($(window).width()) <= 1200 ? $scope.littleDefs: $scope.bigDefs;

  $scope.editMode = false;
  $scope.grid = {
    cellEditableCondition  : 'editable && !editMode',
    columnDefs             : 'defs',
    data                   : 'invoice.invoice_items_attributes',
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableRowSelection     : false,
    enableSorting          : false,
    multiSelect            : false,
    rowHeight              : 43,
    rowTemplate            : DynamicColorSelectableRowHtml,
    virtualizationThreshold: 9999
  };

  // determines whether or not a invoice line
  // item's quantity can be edited.
  $scope.canEditQuantity = function (entity) {
    if ($scope.editable     &&
      !entity.is_bom_parent &&
      !$scope.editMode      &&
      entity.product_id
    ) {
      return true;
    }

    return false;
  };

  $scope.viewVehicleBranchHistory = function (invoice) {
    vehicleApi.viewBranchHistory($scope.vehicle);
  };

  $scope.showCostField = function() {
    $scope.Invoice.save({ skipRefresh: true })
    .then(() => workshopAPI.get('/invoice/update_cost_field', [$scope.invoice.id, false]))
    .then(() => {
      $state.reload();
    });
  };

  $scope.hideCostField = function() {
    $scope.Invoice.save({ skipRefresh: true })
    .then(() => workshopAPI.get('/invoice/update_cost_field', [ $scope.invoice.id, true ]))
    .then(() => {
      $state.reload();
    });
  };

  $scope.addInvoiceNotes = function() {
    $scope.Invoice.save().then(function(invoice) {
      $state.go('app.add-invoice-notes', {
        invoice_id: invoice.id
      });
    });
  };

  $scope.toggleEditMode = function () {
    if ($scope.invoice.invoice_items_attributes[0].ordering === null) {
      reorderGrid.resetIndexes($scope.invoice.invoice_items_attributes);
    }

    $scope.grid.$gridScope.enableCellEditOnFocus = !$scope.grid.$gridScope.enableCellEditOnFocus;
    $scope.grid.selectAll(false);

    $scope.editMode = !$scope.editMode;

    if (!$scope.editMode) {
      $scope.$broadcast('endGridReorder');
    }

  };

  $scope.getEventURL = function(eventDetails) {
    if (!eventDetails) {
      return '';
    }

    return eventDetails.vehicle_id ? '#/' + eventDetails.customer_id + '/' + eventDetails.vehicle_id + '/event/' + eventDetails.id :
    '#/' + eventDetails.customer_id + '/event/' + eventDetails.id;
  };

  $scope.move = function (direction) {
    $scope.Invoice.form.$setDirty();
    return reorderGrid.moveItem($scope.invoice.invoice_items_attributes, direction);
  };

  $scope.setFlagsAndFunctions = function() {
    let hasGroupTax = false;

    angular.forEach($scope.invoice.invoice_items_attributes, function (item, idx) {

      if (!$scope.Invoice.invoice.repco && item.repco_sku) {
        $scope.Invoice.invoice.repco = true;
      }

      if (!$scope.Invoice.invoice.ashdown && $scope.Ashdown.hasSku(item)) {
        $scope.Invoice.invoice.ashdown = true;
      }

      if (!$scope.Invoice.invoice.prolink && $scope.PROLink.hasSku(item)) {
        $scope.Invoice.invoice.prolink = true;
      }

      item.getTotal = function () {
        return $scope.Invoice.totals.itemTotals.total(item);
      };

      item.getTax = function () {
        return $scope.Invoice.totals.itemTotals.tax(item);
      };

      item.ordering = item.ordering && item.ordering === 0 ? item.ordering: idx * 1000000;

      hasGroupTax = hasGroupTax || ( item.sales_tax_rate && item.sales_tax_rate !== $scope.company.sales_tax_rate );
    });

    $scope.Invoice.totals.hasGroupTax = hasGroupTax;

    if ( hasGroupTax ) {
      $scope.initDiscount();
    }
  };

  $scope.prepInvoice = function () {
    $scope.invoice.customer_deposits_attributes = $scope.invoice.customer_deposits_attributes || [];
    $scope.invoice.itemsToDelete                = [];
    $scope.invoice.depositsToDelete             = [];
    $scope.savedTotal                           = $scope.invoice.total;
    $scope.savedBalance                         = $scope.invoice.balance_due;
    $scope.invoice.tax_free                     = $scope.customer.tax_free;
    $scope.invoice.paid                         = $scope.Invoice.totals.paid();
    $scope.invoice.discount_type                = $scope.invoice.discount_type || 'C';

    if ($scope.invoice.invoice_items_attributes.length) {
      $scope.setFlagsAndFunctions();
    }
    else {
      $scope.addItem();
    }

    $scope.calculateTotals();
  };

  $scope.calculateTotals = function () {

    // if invoice discount type is itemized,
    // calculate discount. This must occur
    // before the following calculations.
    if ($scope.Invoice.discountType('itemized')) {
      $scope.invoice.discount = $scope.Invoice.totals.totalItemizedDiscount();
    }

    $scope.invoice.subtotal             = $scope.Invoice.totals.subtotal({discount: true});
    $scope.invoice.gst                  = $scope.Invoice.totals.tax();
    $scope.invoice.total                = $scope.Invoice.totals.total();
    $scope.invoice.balance_due          = $scope.Invoice.totals.balance();
    $scope.invoice.rounding             = $scope.Invoice.totals.rounding();
    $scope.invoice.paid                 = $scope.Invoice.totals.paid();
    $scope.invoice.discount_on_subtotal = $scope.Invoice.totals.subtotalDiscount();
    $scope.invoice.discount_total       = $scope.Invoice.totals.totalDiscount();
  };

  $scope.addItem = function() {
    $scope.invoice.invoice_items_attributes.push($scope.Invoice.getInitialInvoiceItem());

    $scope.setFlagsAndFunctions();
  };

  $scope.removeItem = function (row, replace = false) {
    var deletedBoms = [];

    return $q.when()
    .then(() => {
      if (row.entity.is_bom_parent) {
        for (let i = row.rowIndex + 1; i < $scope.invoice.invoice_items_attributes.length; ++i) {
          var item = $scope.invoice.invoice_items_attributes[i];

          if (item.is_bom_parent || !item.bom_parent_id) {
            break;
          }
          else if (item.bom_id === row.entity.bom_id) {
            item._destroy = '1';

            deletedBoms.push($scope.invoice.invoice_items_attributes.splice(i--, 1)[0]);
          }
        }
      }

      return $q.when(true);
    })
    .then(() => $scope.invoice.id && row.entity.id && row.entity.requires_serial_number
      ? workshopAPI.get('/product_serial_numbers/serial_number_list_by_invoice_item_count', row.entity.id)
        .then(count => count
          ? confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBERS_CONNECTED_REUSE'))
          .then(() => workshopAPI.patch('/product_serial_numbers/remove_serial_numbers_on_delete', row.entity.id, 'product_serial_number'))
          .then(() => messages.show($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBERS_MADE_AVAILABLE'), 'success'))
          : $q.when(true)
        )
      : $q.when(true)
    )
    .then(() => {
      const deletedItem = $scope.invoice.invoice_items_attributes.splice(row.rowIndex, 1);

      deletedItem[0]._destroy = '1';

      $scope.invoice.itemsToDelete = $scope.invoice.itemsToDelete.concat(deletedItem);
      $scope.invoice.itemsToDelete = $scope.invoice.itemsToDelete.concat(deletedBoms);

      if ( replace ) {
        $scope.Invoice.replaceInvoiceItem(deletedItem[0], row.rowIndex);
      }

      if (row.entity.repco_sku) {
        var items = $scope.invoice.invoice_items_attributes.filter(item => item.repco_sku);

        $scope.Invoice.invoice.repco = items.length;
      }

      if (row.entity.ashdown_ingram_sku) {
        $scope.Invoice.invoice.ashdown = $scope.Ashdown.hasSku();
      }

      if (row.entity.prolink_sku) {
        $scope.Invoice.invoice.prolink = $scope.PROLink.hasSku();
      }

      $scope.setFlagsAndFunctions();

      return $q.when();
    })
    .catch(err => {
      message.error(err);

      return $q.reject(false);
    });
  };

  $scope.addNotes = function(row) {
    $uibModal.open({
      templateUrl: AddNoteHtml,
      resolve    : {
        item: function () {
          return row.entity;
        },
        editable: function () {
          return $scope.editable;
        }
      },
      controller: [ '$scope', '$uibModalInstance', 'item', 'editable', function ($scope, $uibModalInstance, item, editable) {
        $scope.item = item;
        $scope.editable = editable;

        $scope.save = function () {
          $uibModalInstance.close(item);
        };

        $scope.close = function () {
          $uibModalInstance.dismiss(false);
        };
      }]
    }).result.then(function (item) {
      row = item;
      $scope.Invoice.form.$setDirty();
    });
  };

  $scope.productDetail = function(row) {
    var modalInstance = $uibModal.open({
      templateUrl: ProductInfoHtml,
      windowClass: 'lg-modal',
      resolve    : {
        product: function () {
          var id = row.entity.product_id;
          return id ? workshopAPI.get('/product', id): '';
        },
        currency: function () {
          return $scope.currency;
        },
        company: function () {
          return $scope.company;
        }
      },
      controller: [ '$scope', '$uibModalInstance', '$translate', 'product', 'currency', 'company', function ($scope, $uibModalInstance, $translate, product, currency, company) {
        var productTypes = {
          A: $translate.instant('PRODUCT_TYPES.SUBLETS'),
          J: $translate.instant('PRODUCT_TYPES.LABOUR'),
          S: $translate.instant('PRODUCT_TYPES.STOCK'),
          T: $translate.instant('PRODUCT_TYPES.TYRES'),
          W: $translate.instant('PRODUCT_TYPES.CONSUMABLE'),
          X: $translate.instant('PRODUCT_TYPES.ACCESSORIES')
        };

        $scope.product = product;
        $scope.product.retail_price = currency.symbol + $scope.product.retail_price;
        $scope.product.maximum = $scope.product.maximum ? $scope.product.maximum : 0;
        $scope.product.minimum = $scope.product.minimum ? $scope.product.minimum : 0;
        $scope.product.product_type = productTypes[$scope.product.product_type];

        $scope.company = company;

        $scope.qtyAvailable =  productApi.calculateQtyAvailable($scope.product);

        $scope.close = function () {
          $uibModalInstance.dismiss(false);
        };
      }]
    });

    modalInstance.result.then(function (item) {
      row = item;
      $scope.Invoice.form.$setDirty();
    });
  };

  $scope.productSearch = {
    // The field that indicates and item has already been found
    identifier : 'product_id',
    search     : typed => productSearchApi.reservedStockSearch(typed),
    /**
     * Instead of a stream search, there are
     * cases (barcode scan) where we just want
     * a quick find on the code without delaying
     * tab or anything. This is the call for that.
     * @param  {string} typed The entered value to search off of
     * @return {promise}         A promise related to the http call for product
     */
    quickSearch: typed => productSearchApi.quickSearch(typed),
    format     : product => angular.isObject(product) ? product.item_code: product,
    getAdjustedCost (item, row) {
      const product = $scope.invoice.invoice_items_attributes[row.rowIndex];

      productSearchApi.getAdjustedCost('invoice', $scope.customer, item)
      .then(price => {
        product.unit_price            = price;
        product.adjusted_retail_price = $scope.Invoice.totals.itemTotals.singleItemTotal(product);
      });
    },
    getBomItems (item, row) {
      $scope.invoice.invoice_items_attributes[row.rowIndex].unit_price    = 0;
      $scope.invoice.invoice_items_attributes[row.rowIndex].is_bom_parent = true;
      $scope.invoice.invoice_items_attributes[row.rowIndex].bom_id        = `${item.item_code}-${row.rowIndex}`;

      productSearchApi.getBomItems('invoice', item, [item.id, $scope.customer.id])
      .then(items => items.map(bom => {
        bom.bom_id = $scope.invoice.invoice_items_attributes[row.rowIndex].bom_id;

        return bom;
      }))
      .then(items => {
        $scope.invoice.invoice_items_attributes.splice(row.rowIndex + 1, 0, ...items);

        $scope.setFlagsAndFunctions();
      });
    },
    populate (item, row, isNewProduct) {
      productApi.getSalesTaxRate(item)
      .then(taxRate => {
        // Reset the row when updating the existing BOM parent
        if ( $scope.invoice.invoice_items_attributes[ row.rowIndex ].is_bom_parent ) {
          $scope.invoice.invoice_items_attributes[ row.rowIndex ].is_bom_parent = false;

          const deletedBoms = [];

          for ( let i = row.rowIndex + 1; i < $scope.invoice.invoice_items_attributes.length; ++i ) {
            const item = $scope.invoice.invoice_items_attributes[ i ];

            if ( item.is_bom_parent || !item.bom_parent_id ) {
              break;
            }
            else if ( item.bom_id === row.entity.bom_id ) {
              item._destroy = '1';

              deletedBoms.push($scope.invoice.invoice_items_attributes.splice(i--, 1)[ 0 ]);
            }
          }

          $scope.invoice.itemsToDelete = $scope.invoice.itemsToDelete.concat(deletedBoms);
        }

        $scope.invoice.invoice_items_attributes[row.rowIndex].cost_including_tax         = item.cost_including_tax;
        $scope.invoice.invoice_items_attributes[row.rowIndex].current_quantity_on_hand   = item.quantity_on_hand || 0;
        $scope.invoice.invoice_items_attributes[row.rowIndex].description                = item.description;
        $scope.invoice.invoice_items_attributes[row.rowIndex].dont_update_quantity       = !!item.dont_update_quantity;
        $scope.invoice.invoice_items_attributes[row.rowIndex].item_code                  = item.item_code;
        $scope.invoice.invoice_items_attributes[row.rowIndex].product_id                 = item.id;
        $scope.invoice.invoice_items_attributes[row.rowIndex].product_type               = item.product_type;
        $scope.invoice.invoice_items_attributes[row.rowIndex].product_retail_price       = item.retail_price;
        $scope.invoice.invoice_items_attributes[row.rowIndex].repco_sku                  = item.repco_product_sku;
        $scope.invoice.invoice_items_attributes[row.rowIndex].sales_tax_rate             = taxRate;
        $scope.invoice.invoice_items_attributes[row.rowIndex].unit_cost                  = item.cost;
        $scope.invoice.invoice_items_attributes[row.rowIndex].flat_rate                  = item.flat_rate;

        if (isNewProduct) {
          $scope.invoice.invoice_items_attributes[row.rowIndex].quantity       = 1;
          $scope.invoice.invoice_items_attributes[row.rowIndex].unit_price     = item.retail_price;
          $scope.invoice.invoice_items_attributes[row.rowIndex].update_product = true;
        }
        else {
          $scope.invoice.invoice_items_attributes[row.rowIndex].gst_free               = item.gst_free;
          $scope.invoice.invoice_items_attributes[row.rowIndex].requires_serial_number = item.requires_serial_number;
          $scope.invoice.invoice_items_attributes[row.rowIndex].job_card_note          = item.job_card_comment;
          $scope.invoice.invoice_items_attributes[row.rowIndex].note                   = item.comment;
          $scope.invoice.invoice_items_attributes[row.rowIndex].ordering               = row.rowIndex * 1000000;

          if (item.product_type == 'J' && item.default_labour_quantity > 0){
            $scope.invoice.invoice_items_attributes[row.rowIndex].quantity = item.default_labour_quantity;
          }
          else {
            $scope.invoice.invoice_items_attributes[row.rowIndex].quantity = 1;
          }

          if (!$scope.Invoice.invoice.repco && item.repco_product_sku) {
            $scope.Invoice.invoice.repco = true;
          }

          if (!$scope.Invoice.invoice.ashdown && item.ashdown_ingram_product_sku) {
            $scope.Invoice.invoice.ashdown = true;
          }

          if (!$scope.Invoice.invoice.prolink && item.prolink_product_sku) {
            $scope.Invoice.invoice.prolink = true;
          }

          if (item.is_bom_parent) {
            this.getBomItems(item, row);
          }
          else if ($scope.customer.id) {
            this.getAdjustedCost(item, row);
          }
          else {
            const product = $scope.invoice.invoice_items_attributes[row.rowIndex];

            product.unit_price            = item.retail_price;
            product.adjusted_retail_price = $scope.Invoice.totals.itemTotals.singleItemTotal(product);
          }
        }

        $scope.setFlagsAndFunctions();
      });
    },
    choose (item, row) {
      const self = this;

      $q.when()
      .then(() => row.entity.id && row.entity.product_id !== item.id
        ? $scope.removeItem(row, true)
        : $q.when(true)
      )
      .then(() => {
        $scope.invoice.invoice_items_attributes[row.rowIndex].untouched = false;

        $q.when()
        .then(() => {
          return item.last
          ? productSearchApi.advancedSearch({
              item_code   : item.item_code,
              product_type: 'S'
            }, row)
            .then(selection => {
              return { ...selection.selection, isNewProduct: selection.isNewProduct };
            })
          : $q.when(item);
        })
        .then(product => {
          self.populate(product, row, product.isNewProduct);
        });
      });
    }
  };

  $scope.addTiremetrixReference = function (row) {
    return $q.when().then(() => {
      return $scope.Invoice.closed() ? $q.when($scope.Invoice.invoice) : $scope.Invoice.save();
    }).then(invoice => {
      const item = row.entity.id ? row.entity : invoice.invoice_items_attributes.filter((item, index) => row.rowIndex === index)[0];

      return $scope.Tiremetrix.searchTires(invoice, item);
    }).then(() => {
      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.delete = function() {
    confirm.generic($scope.invoice.loan_car_id
      ? $translate.instant('JS_SPACE.CONFIRM.DELETE_INVOICE_WITH_INSPECTION')
      : $translate.instant('JS_SPACE.CONFIRM.DELETE_INVOICE'))
    .then(() => {
      workshopAPI.delete('/invoice', $scope.invoice.id)
      .then(() => {
        $scope.Invoice.form.$setPristine();

        $state.go('app.transaction-center.jobs');

        messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.INVOICE'), 'success');
      })
      .catch(err => {
        messages.error(err);
      });
    });
  };

  /**
   * responsible for emailing invoices, attachments
   * or both. Pops up a lightbox where the user can
   * compose an email and choose attachments if they
   * so choose.
   * @param  {boolean} sendInvoice Sets the default for the
   * send invoice flag. this will default the toggle on the
   * lightbox.
  */
  $scope.email = function (sendInvoice, sendInspection) {
    return $q.when()
    .then(() => $scope.Invoice.form.$dirty || !$scope.invoice.id
      ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_INVOICE_BEFORE_EMAILING'))
      .then(() => $scope.save())
      : $q.when($scope.invoice))
    .then(invoice => $scope.Invoice.email(invoice, {
      attachments   : $scope.attachments,
      customer      : $scope.customer,
      requestPayment: $scope.Company.hasIntegration('tillpayments-online'),
      sendInvoice,
      sendInspection
    }))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.emailJobCard = function (sendJobCard) {

    var modalInstance = $uibModal.open({
      templateUrl      : EmailJobCardHtml,
      windowClass      : 'lg-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      controller       : 'emailJobCardCtrl',
      resolve          : {
        sendJobCard: function () {
          return sendJobCard;
        },
        attachments: function () {
          return $scope.attachments;
        },
        companyMessages: () => $scope.companyMessages,
        invoice        : function () {
          return $scope.invoice;
        },
        type: function () {
          switch ($scope.invoice.invoice_type) {
            case 'I':
              return $translate.instant('INVOICE_TYPES.INVOICE');
            case 'Q':
              return $translate.instant('INVOICE_TYPES.QUOTE');
            case 'C':
              return $translate.instant('INVOICE_TYPES.CREDIT');
            default:
              return $translate.instant('INVOICE_TYPES.INVOICE');
          }
        },
        customer: function () {
          return $scope.customer;
        },
        vehicle: function () {
          return $scope.vehicle;
        }

      }
    });

    modalInstance.result.then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success');
    }).then(function() {
      $state.reload();
    });

  };

  $scope.isFlatRateEditable = function (product) {
    return $scope.editable
      && !$scope.editMode
      && product.product_id
      && !productApi.isBomParent(product)
      && productApi.isLabor(product);
  };

  $scope.isLaborItem = function (row) {
    return productApi.isLabor(row.entity);
  };

  $scope.isProductCostEditable = function ( row ) {
    const quantity = bigDecimalApi.get(row.entity.current_quantity_on_hand);

    return quantity.isZero() && !$scope.isLaborItem(row);
  };

  $scope.print = {
    invoice: function() {
      var version = $scope.company.invoice_v1 ? 'invoice': 'jasper_invoice';
      if ($scope.Invoice.form.$dirty || !$scope.invoice.id) {
        confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_INVOICE_BEFORE_PRINTING'))
          .then($scope.save)
            .then(function (invoice) {
              $scope.Invoice.openReport(version, invoice.id);
            }).then(function () {
              return $scope.Invoice.logActivity('invoice');
            }).then(function () {
              $state.reload();
            }, function (err) {
              if (err) {
                messages.error(err);
              }
            });
      }
      else {
        $scope.Invoice.openReport(version, invoice.id);
        $scope.Invoice.logActivity('invoice');
      }
    },
    cash_invoice: function() {
      if ($scope.Invoice.form.$dirty || !$scope.invoice.id) {
        confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_INVOICE_BEFORE_PRINTING'))
          .then($scope.save)
            .then(function (invoice) {
              $scope.Invoice.openReport('jasper_cash_invoice', invoice.id);
            }).then(function () {
              return $scope.Invoice.logActivity('cash_invoice');
            }).then(function () {
              $state.reload();
            }, function (err) {
              if (err) {
                messages.error(err);
              }
            });
      }
      else {
        $scope.Invoice.openReport('jasper_cash_invoice', invoice.id);
        $scope.Invoice.logActivity('cash_invoice');
      }
    },
    job_card: function() {
      var version = $scope.company.job_card_v2 ? 'jasper_job_card': 'job_card';

      if ($scope.invoice.bursons_note ) {

        if ($scope.Invoice.form.$dirty || !$scope.invoice.id) {
          messages.show($translate.instant('JS_SPACE.MESSAGES.MUST_SAVE_INVOICE_BEFORE_PRINTING'), 'warning');
        }
        else if ( sessionObjAPI.user().use_bursons_job_card) {
          $scope.Invoice.openReport(version, $scope.invoice.id, true);
          $scope.Invoice.logActivity('job_card');
        }
        else if ( sessionObjAPI.user().use_bursons_job_card === false) {
          $scope.Invoice.openReport(version, $scope.invoice.id, false);
          $scope.Invoice.logActivity('job_card');
        }
        else {
          $uibModal.open({
            templateUrl: BursonJobCardHtml,
            controller : ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
              $scope.remember = false;

              $scope.yes = function () {
                $uibModalInstance.close({
                  addBurson: true,
                  remember : $scope.remember
                });
              };

              $scope.no = function () {
                $uibModalInstance.close({
                  addBurson: false,
                  remember : $scope.remember
                });
              };
            }]
          }).result.then(function (result) {
            if (result.remember) {
              var user = {
                id                  : sessionObjAPI.user().id,
                use_bursons_job_card: result.addBurson
              };

              workshopAPI.patch('/user', user, 'user').then(function () {
                sessionObjAPI.refresh().then(function () {
                  $scope.Invoice.openReport(version, $scope.invoice.id, result.addBurson);
                }).then(function(){
                  $scope.Invoice.logActivity('job_card');
                });
              });
            }
            else {
              $scope.Invoice.openReport(version, $scope.invoice.id, result.addBurson);
              $scope.Invoice.logActivity('job_card');
            }
          });
        }
      }

      if (($scope.invoice.repco_note || $scope.invoice.prolink_note || $scope.invoice.ashdown_ingram_note)) {

        if ($scope.Invoice.form.$dirty || !$scope.invoice.id) {
          messages.show($translate.instant('JS_SPACE.MESSAGES.MUST_SAVE_INVOICE_BEFORE_PRINTING'), 'warning');
        }
        else if ( sessionObjAPI.user().use_repco_job_card) {
          $scope.Invoice.openReport(version, $scope.invoice.id, true);
          $scope.Invoice.logActivity('job_card');
        }
        else if ( sessionObjAPI.user().use_repco_job_card === false ) {
          $scope.Invoice.openReport(version, $scope.invoice.id, false);
          $scope.Invoice.logActivity('job_card');
        }
        else {

          $uibModal.open({
            templateUrl: RepcoJobCardHtml,
            controller : ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
              $scope.remember = false;

              $scope.yes = function () {
                $uibModalInstance.close({
                  addRepco: true,
                  remember: $scope.remember
                });
              };

              $scope.no = function () {
                $uibModalInstance.close({
                  addRepco: false,
                  remember: $scope.remember
                });
              };
            }]
          }).result.then(function (result) {
            if (result.remember) {
              var user = {
                id                : sessionObjAPI.user().id,
                use_repco_job_card: result.addRepco
              };

              workshopAPI.patch('/user', user, 'user').then(function () {
                sessionObjAPI.refresh().then(function () {
                  $scope.Invoice.openReport(version, $scope.invoice.id, result.addRepco);
                }).then(function(){
                    $scope.Invoice.logActivity('job_card');
                });
              });
            }
            else {
              $scope.Invoice.openReport(version, $scope.invoice.id, result.addRepco);
              $scope.Invoice.logActivity('job_card');
            }
          });
        }
      }

      if (!$scope.invoice.repco_note && !$scope.invoice.prolink_note && !$scope.invoice.ashdown_ingram_note && !$scope.invoice.bursons_note ) {
        $scope.Invoice.openReport(version, $scope.invoice.id, false);
        $scope.Invoice.logActivity('job_card');
      }
    }
  };

  $scope.save = function (options) {
    return $scope.Invoice.save(options);
  };

  $scope.process = function () {
    $q.when()
    .then(() => {
      return $scope.invoice.id ?
        $scope.Invoice.validateAttachments($scope.invoice)
        .then(attachments => {
          let message;

          if (attachments.openOrders == 'true' && attachments.openInvoices == 'true') {
            message = $translate.instant('JS_SPACE.CONFIRM.OPEN_ORDERS_INVOICES_ATTACHED');
          }
          else if (attachments.openOrders == 'true') {
            message = $translate.instant('JS_SPACE.CONFIRM.OPEN_ORDERS_ATTACHED');
          }
          else if (attachments.openInvoices == 'true') {
            message = $translate.instant('JS_SPACE.CONFIRM.OPEN_INVOICES_ATTACHED');
          }

          return message ? confirm.generic(message) : $q.when(true);
        }) :
        $q.when(true);
    })
    .then(() => $scope.customer.customer_limited ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.CUSTOMER_ACCOUNT_IS_LIMITED')) : $q.when())
    .then(() => $scope.company.has_myob && !$scope.invoice.total ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.MYOB_PRODUCTS')) : $q.when())
    .then(() => $scope.Invoice.process())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.PROCESSED.INVOICE'), 'success');

      if ($scope.invoice.id) {
        $state.reload();
      }
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.addCustomerToVVGarage = function() {
    vvGarageApi.addCustomer($scope.customer)
    .then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.CUSTOMER_ADDED_TO_VV_GARAGE'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });

  };

  $scope.removeCustomerFromVVGarage = function() {
    vvGarageApi.deleteCustomer($scope.customer)
    .then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.CUSTOMER_REMOVED_FROM_VV_GARAGE'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.submit = function () {
    $scope.loading = true;
    $q.when().then(function () {
      return $scope.customer.customer_limited ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.CUSTOMER_ACCOUNT_IS_LIMITED')): $q.when();
    }).then(function () {
      return $scope.save();
    }).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.INVOICE'), 'success');
      $scope.loading = false;
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.addLabor = function(row) {
    if (!$scope.editable) {
      $state.go('app.labor-items', {
        invoice_id     : $scope.invoice.id,
        invoice_item_id: $scope.invoice.invoice_items_attributes[row.rowIndex].id
      });
      return;
    }
    $scope.save().then(function(invoice) {
      $timeout(function () {
        $state.go('app.labor-items', {
          invoice_id     : invoice.id,
          invoice_item_id: invoice.invoice_items_attributes[row.rowIndex].id
        });
      });
    }, function(err) {
      messages.error(err);
    });
  };

  $scope.updateUnitCost = function(row) {
    return $scope.Invoice.updateUnitCost(row);
  };

  $scope.addFromGsf = function () {
    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {
      name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.GSF.GSF')
    }), null, 'gsfInvoiceAutoSave')
    .then(() => $scope.Invoice.save())
    .then(invoice => gsfApi.getPortalUrl('invoice', $scope.vehicle, invoice.id))
    .then(url => {
      windowApi.open(url, '_blank')
      .then(isVisible => {

        $state.reload();
      });
    })
    .catch(err => {
      if ( err ) {
        messages.error(err);
      }
    });
  };

  $scope.addItemFromRepco = function () {
    var origin = sessionObjAPI.base().origin;

    var getUrl = function (invoice) {
      if ($scope.vehicle.id) {
        return `${origin}workshop.html#/${$scope.customer.id}/${$scope.vehicle.id}/invoice/${invoice.id}`;
      }
      else {
        return `${origin}workshop.html#/${$scope.customer.id}/invoice/${invoice.id}`;
      }
    };

    var buildQuery = function (url, invoice) {
      var queryString = {
        hookUrl   : url,
        type      : 'inquiry',
        invoice_id: invoice.id,
      };

      if ($scope.vehicle) {
        const vehicle = angular.copy($scope.vehicle);

        delete vehicle.follow_up_comment;

        queryString.vehicleInfo = JSON.stringify(vehicle);

        queryString['NEW_ITEM-CUST_FIELD6[1]']  = $scope.vehicle.make;
        queryString['NEW_ITEM-CUST_FIELD7[1]']  = $scope.vehicle.model;
        queryString['NEW_ITEM-CUST_FIELD22[1]'] = $scope.vehicle.plate_number;
        queryString['NEW_ITEM-CUST_FIELD23[1]'] = $scope.vehicle.plate_state;
      }

      queryString['HOOKURL'] = `${API.url}/invoices/add_item_from_repco/${invoice.id}`;

      return $.param(queryString);
    };

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name: 'Repco' }), null, 'repcoInvoiceAutoSave')
      .then($scope.save).then(function (invoice) {
        var url = getUrl(invoice);
        var queryString = buildQuery(url, invoice);

        $timeout(function () {
          $window.location.assign(`/repco.html?${queryString}`);
        });
      }, function (err) {
        if (err) {
          messages.error(err);
        }
      });
  };

  $scope.addItemsFromPartstech = function () {
    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name: 'Partstech' }), null, 'partsTechInvoiceAutoSave').then(() => {
      return $scope.Invoice.save();
    }).then(invoice => {
      return partstechApi.requestSession('invoice', invoice);
    }).then(url => {
      $window.location.assign(url);
    }).catch(err => {
      if (err) {
        messages.error(err);
      }
    });
  };

  $scope.quoteToEvent = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_QUOTE_FOR_BOOKING'))
      .then(function () {
        $scope.save().then(function (quote) {
          $timeout(function () {
            workshopAPI.get('/invoice/quote_to_event', quote.id)
              .then(function (data) {
                $state.go('app.event', {
                  customer_id: data.customer_id,
                  vehicle_id : data.vehicle_id,
                  id         : data.event_id
                });
              }, function (err) {
                messages.error(err);
              });
          });
        }, function (err) {
          messages.error(err);
        });
      });
  };

  $scope.copyInvoice = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.COPY_INVOICE'))
    .then(() => workshopAPI.get('/invoice/copy_invoice', $scope.invoice.id))
    .then(invoice => {
      sessionObjAPI.setKey('invoice_copy', invoice);

      $state.go('app.invoice', {
        customer_id: invoice.customer_id,
        vehicle_id : invoice.vehicle_id,
        id         : invoice.id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.createPurchaseOrder = function () {
    $scope.save().then(function (invoice) {
      return $scope.Invoice.productListForOrdering(invoice);
     }, function (err) {
        messages.error(err);
    });

  };

  $scope.editInvoice = function () {
    $scope.Invoice.editInvoice();
  };

  $scope.invoiceAnalysis = function () {
    return $q.when()
    .then(() => invoiceApi.isStatus($scope.invoice, 'open')
      ? $scope.Invoice.save()
      : $q.when($scope.invoice)
    )
    .then(invoice => invoiceApi.viewAnalysis(invoice));
  };

  $scope.createCredit = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.CREATE_CREDIT'))
    .then(() => workshopAPI.get('/invoice/tillpayments_invoice_to_credit', $scope.invoice.id))
    .then(invoice => {
      sessionObjAPI.setKey('invoice_copy', invoice);

      $state.go('app.invoice', {
        customer_id: invoice.customer_id,
        vehicle_id : invoice.vehicle_id,
        id         : invoice.id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.createRepcoPO = function () {

    // Save first
    $scope.save().then(function (invoice) {

      // Get all open purchase orders for the repco vendor
      workshopAPI.get( '/vendors/purchase_order_list', [ $scope.company.repco_settings.repco_vendor_id, 0, '*', 'S', 'order_date', 'desc' ] )
        .then(function (pos) {
          var count = pos.length;

          // If there are more than one, make them choose one or create a new
          if (parseInt(count) > 1) {
            $uibModal.open({
              templateUrl: RepcoOrdersHtml,
              controller : 'repcoPOList',
              windowClass: 'md-modal',
              size       : 'lg',
              resolve    : {
                vendor_id: function () {
                  return $scope.company.repco_settings.repco_vendor_id;
                },
                purchase_orders: function () {
                  return pos;
                }
              }
            }).result.then(function (id) {
              // Either a po id or the string 'new'. Now we can do the call
              workshopAPI.get('/invoice/create_repco_order', [ invoice.id, id ])
                .then(function (po) {
                  messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.REPCO_ORDER'), 'success');
                  $state.go('app.purchase-order', {
                    vendor_id: $scope.company.repco_settings.repco_vendor_id,
                    id       : po.purchase_order_id
                  });
                }, function (err) {
                  messages.error(err);
                });
            });
          }

          // If there is only one, give them the option of using that one or creating a new one.
          else if (count === 1) {
            $uibModal.open({
              templateUrl: RepcoOrderConfirmationHtml,
              resolve    : {
                po: function () {
                  return pos[0];
                }
              },
              controller: [ '$scope', '$uibModalInstance', 'po', function ($scope, $uibModalInstance, po) {
                $scope.po = po;

                $scope.add = function () {
                  $uibModalInstance.close(pos[0].id);
                };

                $scope.new = function () {
                  $uibModalInstance.close('new');
                };
              }]
            }).result.then(function (id) {
              // Either a po id or the string 'new'. Now we can do the call
              workshopAPI.get('/invoice/create_repco_order', [ invoice.id, id ])
                .then(function (po) {
                  if (id === 'new') {
                    messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.PURCHASE_ORDER'), 'success');
                  }
                  else {
                    messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.ORDER'), 'success');
                  }
                  $state.go('app.purchase-order', {
                    vendor_id: $scope.company.repco_settings.repco_vendor_id,
                    id       : po.purchase_order_id
                  });
                }, function (err) {
                  messages.error(err);
                });
            });
          }

          // If none, create a new one
          else {
            workshopAPI.get('/invoice/create_repco_order', [invoice.id, 'new'] )
              .then(function (po) {
                messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.PURCHASE_ORDER'), 'success');
                $state.go('app.purchase-order', {
                  vendor_id: $scope.company.repco_settings.repco_vendor_id,
                  id       : po.purchase_order_id
                });
              }, function (err) {
                messages.error(err);
              });
          }
        });
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('invoice').then(function (templates) {
      angular.forEach(templates, function (template) {
        if ($scope.invoice.note) {
          $scope.invoice.note = $scope.invoice.note + '</br>' + template.wording;
        }
        else {
          $scope.invoice.note = template.wording;
        }
      });
    });
  };

  $scope.addJobCardTemplates = function () {
    templatedWording.addTemplate('job_card').then(function (templates) {
      angular.forEach(templates, function (template) {
        if ($scope.invoice.job_card_note) {
          $scope.invoice.job_card_note = $scope.invoice.job_card_note + '\n\n' + template.wording;
        }
        else {
          $scope.invoice.job_card_note = template.wording;
        }
      });
    });
  };

  $scope.addItemsFromBurson = function () {
    $scope.disableBurson = true;

    $q.when()
    .then(() => $scope.invoice.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name: 'Burson EzyParts' }), null, 'bursonInvoiceAutoSave'))
    .then(() => $scope.Invoice.save())
    .then(invoice => bursonApi.getUrl('invoice', invoice))
    .then(url => $window.location.assign(url))
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $state.reload();

      $scope.disableBurson = false;
    });
  };

  $scope.addItemsFromHsy = function () {
    $q.when().then(() => {
      return $scope.invoice.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name: 'HSY' }), null, 'hsyInvoicesAutoSave');
    }).then(() => {
      return $scope.invoice.id ? $q.when($scope.invoice) : $scope.Invoice.save();
    }).then(invoice => {
      return $scope.HsyItems.getPortalUrl(invoice);
    }).then(url => {
      $window.location.assign(url);
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.addItemsFromPartsAuthority = function () {
    $q.when().then(() => {
      return $scope.invoice.id ? $q.when($scope.invoice) :
        confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {
          name: 'Parts Authority'
        }), null, 'partsAuthorityInvoicesAutoSave').then(() => {
          return $scope.Invoice.save();
        });
    }).then(invoice => {
      return $scope.PartsAuthorityInvoice.getPortalUrl(invoice);
    }).then(url => {
      $window.location.assign(url);
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.addItemsFromOscar = function () {
    $scope.disableOscar = true;

    $scope.OscarInvoices.addItems().then(result => {
      messages.show(result, 'success');
    }).catch(err => {
      messages.error(err);
    }).finally(() => {
      $state.reload();
      $scope.disableOscar = false;
    });
  };

  $scope.addItemsFromTireconnect = function () {
    $q.when()
    .then(() => {
      return $scope.invoice.id ?
        $q.when($scope.Invoice.invoice) :
        confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {
          name: 'Tireconnect'
        }), null, 'tireconnectInvoicesAutoSave')
        .then(() => $scope.Invoice.save());
    })
    .then(invoice => tireconnectApi.getPortalUrl($scope.vehicle, invoice.id, 'invoice'))
    .then(url => {
      const newWindow = $window.open(url, '_blank');

      newWindow.onbeforeunload = function () {
        sessionObjAPI.removeKey(tireconnectApi.storageKey);

        $state.reload();
      };
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.addItemsFromMitchell1 = function () {
    $q.when().then(() => {
      return $scope.invoice.id ?
        $q.when($scope.Invoice.invoice) :
        confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name: 'Mitchell1' }), null, 'mitchell1InvoicesAutoSave').then(() => {
          return $scope.Invoice.save();
        });
    }).then(invoice => {
      return $scope.Mitchell1.addItems(invoice)
      .then(() => $scope.Mitchell1.cleanup());
    }).then(() => {
      $state.reload();

      messages.show($translate.instant('MITCHELL1_SPACE.ITEMS_ADDED'), 'success');
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.addLaborFromHaynesPro = function () {
    let savedInvoice;

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {
      name: haynesProApi.lookupsTitle
    }), null, 'haynesProInvoiceAutoSave')
    .then(() => $scope.Invoice.save())
    .then(invoice => {
      savedInvoice = invoice;

      return vehicleApi.get($scope.vehicle.id);
    })
    .then(vehicle => {
      $scope.vehicle = vehicle;

      return haynesProApi.addLaborTimes($scope.vehicle, savedInvoice.id, 'invoice');
    })
    .then(() => {
      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.LABOUR_TIMES_ADDED'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.void = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.VOID_INVOICE'))
      .then(function () {
        return $scope.Invoice.void();
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.VOIDED.INVOICE'), 'success');
        $state.go('app.transaction-center.jobs');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);

    if ($scope.Invoice.closed()) {
      classes.push('readonly');
    }
    else if ($scope.editMode && item.selected) {
      classes.push('selected');
    }
    else if ($scope.editMode && item.active) {
      classes.push('active');
    }
    else if (!$scope.editMode && item.is_bom_parent) {
      classes.push('bom-parent');
    }
    else if (!$scope.editMode && item.bom_parent_id) {
      classes.push('bom-child');
    }

    return classes;
  };

  $(window).resize(function(){
    if (parseInt($(window).width()) <= 1200) {
      $scope.defs = $scope.littleDefs;
    }
    else {
      $scope.defs = $scope.bigDefs;
    }
  });

  $scope.refundCredit = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.REFUND_AMOUNT_INVOICE', {
      amount: $filter('currency')($scope.invoice.balance_due, $scope.currency.symbol),
      name  : $scope.customer.display_name
    }))
    .then(() => cashInvoiceApi.process($scope.invoice, null))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INVOICE_REFUNDED'), 'success');

      $state.reload();
    })
    .catch(err => messages.error(err));
  };

  $scope.followUp = function () {
    modalApi.addNote({
      note: $scope.invoice.follow_up_comment
    })
    .then(note => {
      $scope.invoice.follow_up_comment = note;
    });
  };

  $scope.addDeposit = function (index) {
    $scope.Invoice.deposit.add(index).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.DEPOSIT_ADDED'), 'success');
    });
  };

  $scope.rework = function () {
    $scope.Invoice.rework().then(function (data) {
      return workshopAPI.patch('/invoice/mark_as_rework', data);
    }).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INVOICE_MARKED_AS_REWORK'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.cancelDiscount = function () {
    $scope.invoice.discount = $scope.originalDiscount;

    $scope.toggleDiscount();
  };

  $scope.confirmDiscount = function () {
    if ( $scope.Invoice.form.discount.$valid ) {
      $scope.originalDiscount = $scope.invoice.discount;

      $scope.calculateTotals();
      $scope.toggleDiscount();
    }
  };

  $scope.toggleDiscount = function () {
    $scope.showDiscount = !$scope.showDiscount;
  };

  $scope.changeCustomer = function () {
    $scope.Customer.change().then(function (customer) {
      return workshopAPI.get('invoices/change_customer', [$scope.invoice.id, customer.id]);
    }).then(function (invoice) {
      $state.go('app.invoice', {
        customer_id: invoice.customer_id,
        id         : invoice.id,
        vehicle_id : null
      });
      messages.show($translate.instant('JS_SPACE.MESSAGES.CHANGED.CUSTOMER'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.split = function () {
    if (!$scope.session.gold_or_higher) {
      messages.error($translate.instant('COMPANY_SPACE.SUBSCRIPTION.FEATURE_ONLY_AVAILABLE_ON_GOLD'));
    } else {
      $scope.Invoice.split().then(function (data) {
        messages.show($translate.instant('JS_SPACE.MESSAGES.INVOICE_SPLIT_SUCCESSFULLY'), 'success');

        $state.go('app.invoice', {
            customer_id: data.customer_id,
            vehicle_id : data.vehicle_id,
            id         : data.new_invoice_id
        }, {
          inherit: false
        });
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.sendSms = function( isJobCard = false ) {
    const hasWpay = $scope.Company.hasIntegration('tillpayments-online') && $scope.Invoice.type('invoice');

    const disclaimer = hasWpay
      ? $translate.instant('JS_SPACE.MESSAGES.INVOICE_SMS_DISCLAIMER_PAYMENT_REQUEST')
      : $translate.instant('JS_SPACE.MESSAGES.INVOICE_SMS_DISCLAIMER', {
        type: isJobCard
          ? 'job card'
          : $filter('invoiceType')($scope.invoice.invoice_type).toLowerCase()
      });

    const sms = {
      attachment_type: isJobCard ? 'jobcard' : 'invoice',
      customer_id    : customer.id,
      disclaimer     : disclaimer,
      invoice_id     : $scope.invoice.id,
      message        : $scope.companyMessages.default_invoice_sms_message,
      name           : customer.display_name,
      send_to        : customer.mobile,
      request_payment: hasWpay,
    };

    $q.when()
    .then(() => isJobCard
      ? messengerApi.sms(sms, {
          requestPayment: hasWpay
        })
      : invoiceApi.sendSms($scope.invoice, sms))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.sendSmsToCustomer = function () {
    messengerApi.sms({
      customer_id: $scope.customer.id,
      name       : $scope.customer.display_name,
      send_to    : $scope.customer.mobile
    }).
    then(() => messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success'));
  };

  $scope.sendJobCardSms = function () {
    messengerApi.sms({
      attachment_type: 'jobcard',
      customer_id    : customer.id,
      disclaimer     : $translate.instant('JS_SPACE.MESSAGES.JOB_CARD_PDF_DISCLAIMER'),
      invoice_id     : $scope.invoice.id,
      message        : `View your job card from ${$scope.Company.company.company_name}: `,
      name           : customer.display_name,
      send_to        : customer.mobile
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });
  };

  $scope.useSerialNumber = function (row) {
    $scope.Invoice.save()
    .then(invoice => {
      return $uibModal.open({
        controller       : 'InvoiceSerialNumbersCtrl',
        templateUrl      : InvoiceSerialNumbersCtrl,
        windowClass      : 'flip-container lg-modal',
        windowTemplateUrl: WindowFlipHtml,
        resolve          : {
          item () {
            return invoice.invoice_items_attributes[row.rowIndex];
          },
          available_serial_numbers () {
            return workshopAPI.get('/product_serial_numbers/serial_number_list_by_product', [ invoice.invoice_items_attributes[row.rowIndex].product_id, true ]);
          },
          selected_serial_numbers () {
            return workshopAPI.get('/product_serial_numbers/serial_number_list_by_invoice_item', [ invoice.invoice_items_attributes[row.rowIndex].id ]);
          },
          editable () {
            return $scope.invoice.invoice_status === 'O';
          }
        }
      }).result;
    })
    .finally(() => {
      $state.reload();
    });
  };

  // if the invoice type was changed to internal,
  // we need to make sure the customer id is that
  // of the internal customer. If not, warn the user
  // and refresh the page.
  $scope.validateInvoiceType = function (prevType) {
    $scope.showLinkedInvoices = $scope.setShowLinkedInvoices();

    if (internals && $scope.Invoice.type('internal')) {
      if ($scope.customer.id && $scope.customer.id !== internals.internal_customer_id) {
        confirm.generic($translate.instant('DEALERSHIP_SPACE.NOT_APPROPRIATE_FOR_INTERNAL_INVOICE'))
          .then(function () {

            $state.go('app.invoice', {
                customer_id: internals.internal_customer_id,
                vehicle_id : $scope.invoice.vehicle_id,
                id         : $scope.invoice.id
            });

          }, function (error) {
            $scope.invoice.invoice_type = prevType;

            messages.error(error);
          });
      }
    }
  };

  $scope.viewBranchStock = function (row) {
    productApi.viewBranchStock(row.entity);
  };

  $scope.calculateRRP = function (index) {
    $scope.Invoice.totals.itemTotals.calculateRRP(index);
  };

  $scope.handleItemDiscount = function (row) {

    // ensure that the RRP is
    // defined before opening modal.
    $scope.validateRRP(row.rowIndex);

    $scope.Invoice
      .handleItemDiscount(row.rowIndex)
      .then(item => {
        $scope.invoice.invoice_items_attributes[row.rowIndex] = item;

        // set the itemized discount type if
        // an item discount exists, otherwise,
        // default it to cash.
        if (!!item.discount) {
          $scope.invoice.discount      = $scope.Invoice.totals.totalItemizedDiscount();
          $scope.invoice.discount_type = 'I';
        }
        else if ($scope.Invoice.discountType('itemized') && !$scope.Invoice.isItemizedDiscount()) {
          $scope.initDiscount();
        }

        $scope.setFlagsAndFunctions();
        $scope.calculateTotals();
        $scope.Invoice.form.$setDirty();
      });
  };

  $scope.initDiscount = function () {
    $scope.invoice.discount      = 0;
    $scope.invoice.discount_type = 'C';
  };

  $scope.isGeneralDiscount = function () {
    return ($scope.Invoice.discountType('cash') || $scope.Invoice.discountType('percentage')) && !$scope.Invoice.totals.isZero($scope.invoice.discount);
  };

  $scope.isItemizedDiscount = function (row) {
    return $scope.Invoice.isItemizedDiscount(row ? $scope.invoice.invoice_items_attributes[row.rowIndex] : undefined);
  };

  $scope.validateRRP = function (index) {
    const item = $scope.invoice.invoice_items_attributes[index];

    if (Number(item.unit_price) > Number(item.adjusted_retail_price)) {
      $scope.calculateRRP(index);
    }
  };

  $scope.requestWorkshopPayPayment = function () {
    onlinePaymentsApi.requestSmsPayment($scope.invoice, $scope.customer)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SENT.PAYMENT_REQUEST'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.showAttachedOrders = function () {
    return $scope.Invoice.type('invoice')
      || $scope.Invoice.type('quote')
      || $scope.Invoice.type('internal');
  };

  $scope.serviceAdviserSearch = {
    format: ( adviser ) => adviser.display_name || adviser.service_adviser_display_name,
    list  : [],
    query : ( value ) => workshopAPI.get('/service_advisers/list', [ value, 0, '*' ]),
    select: ( adviser ) => {
      $scope.invoice.assigned_service_adviser_id  = adviser.id;
      $scope.invoice.service_adviser_display_name = adviser.display_name;
    },
    templateUrl: AdviserSearchResultsHtml,
    value      : {
      display_name: $scope.invoice.service_adviser_display_name ? $scope.invoice.service_adviser_display_name : '',
      id          : $scope.invoice.assigned_service_adviser_id
    }
  };

  $scope.convertToJobCard = function () {
    workshopAPI.post('/invoices/convert_quote_to_job_card', {
      invoice_id: $scope.invoice.id
    })
    .then(( invoice ) => {
      $state.go('app.invoice', {
        customer_id: $scope.invoice.customer_id,
        id         : invoice.invoice_id,
        vehicle_id : $scope.invoice.vehicle_id
      }, {
        inherit: false
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.setShowLinkedInvoices = function () {
    return ( $scope.Invoice.type('quote') && jobCards && jobCards.length )
      || ( $scope.Invoice.type('invoice') && quotes && quotes.length && Object.keys(quotes[ 0 ]).length );
  };

  $scope.$watch('invoice.invoice_items_attributes', function (items, oldItems) {
    if (!items.length) {
      $scope.addItem();

      // reset invoice discount if necessary.
      if ($scope.Invoice.discountType('itemized')) {
        $scope.initDiscount();
      }
    }
    if (items !== oldItems) {
      $scope.$emit('calculateTotals');
    }
  }, true);

  $scope.$watch('invoice.tax_group_id', function (newId, oldId) {
    if ((newId !== oldId) && $scope.company.use_multi_tax) {
      $scope.filterTaxGroup(newId);
      $scope.calculateTotals();
    }
  });

  $scope.$on('calculateTotals', $scope.calculateTotals);

  $scope.isTaxZero = function (tax) {
    const quantity = bigDecimalApi.get(tax);

    return quantity.isZero();
  };

  var copy = $scope.Invoice.getCopy();

  if (copy) {
    $scope.invoice = copy;

    if (copy.attachments && copy.attachments.length) {
      confirm.generic($translate.instant('JS_SPACE.CONFIRM.COPY_ATTACHMENTS'))
      .then(() => {
        $scope.attachments = copy.attachments;
      })
      .catch(() => {
        $scope.attachments                 = [];
        $scope.invoice.attachments         = [];
        $scope.Invoice.invoice.attachments = [];
      });
    }
    else {
      $scope.attachments = [];
    }
  }

  if ($scope.company.use_multi_tax && $scope.taxGroups.length && !$scope.invoice.tax_group_id) {
    $scope.invoice.tax_group_id = defaultTaxGroup ? defaultTaxGroup.id: ($scope.company.tax_group_id || $scope.taxGroups[0].id);
    $scope.filterTaxGroup($scope.invoice.tax_group_id);
  }
  else if (( $scope.company.use_multi_tax || $scope.Invoice.closed() ) && $scope.invoice.tax_group_id) {
    $scope.invoice.tax_group = {
      tax_group_items_attributes: $scope.invoice.invoice_tax_items_attributes
    };
  }
  else if (!$scope.company.use_multi_tax) {
    $scope.invoice.tax_group_id = null;
  }

  if (invoice || copy) {
    $scope.prepInvoice();
  }
  else {
    $scope.addItem();
  }

  // if the internal customer used for
  // dealership is selected, restrict
  // the invoice type to internal.
  if (internals && $scope.customer.id) {
    if ($scope.customer.id === internals.internal_customer_id) {
      $scope.invoice.invoice_type = 'U';
      $scope.isInternalCustomer   = true;
    }
  }

  $scope.showLinkedInvoices = $scope.setShowLinkedInvoices();
}